const doc = [({"da":({"js":({"admin":({"activities":({"create_card":({"surveys_card":({"add_survey":"Tilføj spørgeskema"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;